module.exports = __webpack_public_path__ + "img/nivel_rio_hover.e9cdd432.png";